module.exports = __webpack_public_path__ + "img/device-replace-v3-activity.ffce7e5b.png";